import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    confirm: 'I understand',
    description:
      'You are about to archive this invoice, it will appear as "canceled". You can find it in the "Canceled invoices" section, from the "Invoices" tab.',
    errorMessage:
      'An error occurred while canceling your invoice. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    successMessage: 'Your invoice n°{0} has been canceled!',
    title: 'We’re canceling your invoice',
  },
  fr: {
    cancel: 'Annuler',
    confirm: 'J’ai compris',
    description:
      'Vous vous apprêtez à archiver cette facture, elle apparaîtra comme “annulée”. Vous pourrez la retrouver dans la section "Factures annulées", depuis l\'onglet "Factures".',
    errorMessage:
      'Une erreur est survenue lors de l’annulation de votre facture. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    successMessage: 'Votre facture n°{0} a bien été annulée\xA0!',
    title: 'Nous annulons votre facture',
  },
} as const);
